<template>
  <v-avatar :color="color">
    <v-icon :color="iconColor"><slot></slot></v-icon>
  </v-avatar>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "grey lighten-4",
    },
    iconColor: {
      type: String,
      default: "",
    },
  },
};
</script>
